/* eslint-disable max-lines-per-function */
/*eslint max-lines-per-function: ["error", 200]*/
import React, { useCallback, useEffect } from 'react';
import { Card, Tab } from 'react-bootstrap';

import { useCookies } from '../../../common/hooks/useCookies';
import { useSpdCore } from '../../../common/hooks/useSpdCore';
import { useNavigation } from '../../../common/navigation';
import { ExamSearch } from '../../components/Exam/ExamSearch';
import { TabsHistory } from '../../../app/components/TabsHistory';
import { ArticleMode } from '../../../common/spdCore/validation/schemas';

import { ExamsActiveView } from './ExamsActiveView';

export const ExamsDoctorView: React.FC = () => {
  const spd = useSpdCore();
  const nav = useNavigation();
  const cookies = useCookies();

  useEffect(() => {
    if (cookies.activeMonitor !== 'doctor') {
      cookies.setActiveMonitor('doctor');
    }
  }, [cookies]);

  const handleClick = async (id: string) => {
    void nav.examTestsDoctor(id);
  };

  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  const handleSelect = (key: any) => {
    cookies.setActiveTabMonitor(key as string);
  };

  const getDataWithoutJudgment = useCallback(
    (
      pageSize: number,
      pageNumber: number,
      orderBy?: string,
      orderDirection?: string,
      filterText?: string,
      filterColumns?: string,
    ) =>
      spd.exams.getWithoutJudgmentByPortion(
        pageSize,
        pageNumber,
        orderBy,
        orderDirection,
        filterText,
        filterColumns,
        ArticleMode.Doctor,
      ),
    [spd.exams],
  );

  const getDataActive = useCallback(
    (
      pageSize: number,
      pageNumber: number,
      orderBy?: string,
      orderDirection?: string,
      filterText?: string,
    ) =>
      spd.exams.getActiveByPortion(
        pageSize,
        pageNumber,
        orderBy,
        orderDirection,
        filterText,
        ArticleMode.Doctor,
      ),
    [spd.exams],
  );

  // const getDataWithExamined = useCallback(
  //   (
  //     pageSize: number,
  //     pageNumber: number,
  //     orderBy?: string,
  //     orderDirection?: string,
  //     filterText?: string,

  //     filterColumns?: string,
  //   ) =>
  //     spd.exams.getWithExaminedByPortion(
  //       pageSize,
  //       pageNumber,
  //       orderBy,
  //       orderDirection,
  //       filterText,
  //       filterColumns,
  //       ArticleMode.Doctor,
  //     ),
  //   [spd.exams],
  // );

  const getDataAll = useCallback(
    (
      pageSize: number,
      pageNumber: number,
      orderBy?: string,
      orderDirection?: string,
      filterText?: string,

      filterColumns?: string,
    ) =>
      spd.exams.getAllByPortion(
        pageSize,
        pageNumber,
        orderBy,
        orderDirection,
        filterText,
        filterColumns,
        ArticleMode.Doctor,
      ),
    [spd.exams],
  );

  const getCountActive = useCallback(
    (filterText?: string) =>
      spd.exams.getActiveCount(
        filterText,
        undefined,
        undefined,
        ArticleMode.Doctor,
      ),
    [spd.exams],
  );

  const getCountWithoutJudgment = useCallback(
    (filterText?: string, filterColumns?: string) =>
      spd.exams.getWithoutJudgmentCount(
        filterText,
        filterColumns,
        undefined,
        ArticleMode.Doctor,
      ),
    [spd.exams],
  );

  // const getCountWithExamined = useCallback(
  //   (filterText?: string, filterColumns?: string) =>
  //     spd.exams.getWithExaminedCount(
  //       filterText,
  //       filterColumns,
  //       undefined,
  //       ArticleMode.Doctor,
  //     ),
  //   [spd.exams],
  // );

  const getCountAll = useCallback(
    (filterText?: string, filterColumns?: string) =>
      spd.exams.getAllCount(
        filterText,
        filterColumns,
        undefined,
        ArticleMode.Doctor,
      ),
    [spd.exams],
  );

  const getDataBlocked = useCallback(
    (
      pageSize: number,
      pageNumber: number,
      orderBy?: string,
      orderDirection?: string,
      filterText?: string,
      filterColumns?: string,
    ) =>
      spd.exams.getBlockedByPortion(
        pageSize,
        pageNumber,
        orderBy,
        orderDirection,
        filterText,
        filterColumns,
        ArticleMode.Doctor,
      ),
    [spd.exams],
  );

  const getCountBlocked = useCallback(
    (filterText?: string, filterColumns?: string) =>
      spd.exams.getBlockedCount(filterText, filterColumns, ArticleMode.Doctor),
    [spd.exams],
  );

  return (
    <Card>
      <TabsHistory
        activeKey={
          cookies.activeTabMonitor ? cookies.activeTabMonitor : 'activeExams'
        }
        id="exams"
        className="mb-3"
        onAdditionalSelect={handleSelect}
      >
        <Tab
          eventKey="withoutJudgmentExams"
          title="Badania lekarskie z orzeczeniami do wydania"
          className="m-3"
        >
          <ExamSearch
            getData={getDataWithoutJudgment}
            getCount={getCountWithoutJudgment}
            onRowClick={handleClick}
            initialOrderColumn="exams.endDate"
            initialOrderDirection="ASC"
            withFilterInColumns={true}
          />
        </Tab>
        <Tab eventKey="activeExams" title="aktywne" className="m-3">
          <ExamsActiveView
            getData={getDataActive}
            getCount={getCountActive}
            onRowClick={handleClick}
          />
        </Tab>
        {/* <Tab eventKey="examsWithExamined" title="z badanym" className="m-3">
          <ExamSearch
            getData={getDataWithExamined}
            getCount={getCountWithExamined}
            onRowClick={handleClick}
            withFilterInColumns={true}
          />
        </Tab> */}
        <Tab eventKey="blockedExams" title="Zablokowane" className="m-3">
          <ExamSearch
            getData={getDataBlocked}
            getCount={getCountBlocked}
            onRowClick={handleClick}
            withFilterInColumns={true}
          />
        </Tab>
        <Tab
          eventKey="exams"
          title="Wszystkie badania lekarskie"
          className="m-3"
        >
          <ExamSearch
            getData={getDataAll}
            getCount={getCountAll}
            onRowClick={handleClick}
            withFilterInColumns={true}
          />
        </Tab>
      </TabsHistory>
    </Card>
  );
};
